import { apiCall } from "./auth";
import { multipartApiCall } from "./auth";
import { API_URL } from "./config";


export const submitdata = (formdata) => apiCall(`${API_URL}contact/submit`, "POST", formdata);

export const updateremotefittingdataapi = (formdata) => apiCall(`${API_URL}remotefittinginquires/updateRemoteInquirydata`, "POST", formdata);

export const updateremotefittingdatafitterapi = (formdata) => apiCall(`${API_URL}remotefittinginquires/updateremotefittingdatafitter`, "POST", formdata);

export const createremotefittingcamera = (formdata) => apiCall(`${API_URL}remotefittinginquires/createremotefittingcamera`, "POST", formdata);

export const uploadimagetoserver = (formdata) => multipartApiCall(`${API_URL}remotefittinginquires/uploadimagetoserver`, "POST", formdata);

export const updateremotefittingquriesswingstatus = (formdata) => apiCall(`${API_URL}remotefittinginquires/updateremotefittingquriesswingstatus`, "POST", formdata);

export const createnewremotefittingcamera = (formdata) => apiCall(`${API_URL}remotefittinginquires/createnewremotefittingcamera`, "POST", formdata);

export const uploadimagetoattachment = (formdata) => apiCall(`${API_URL}remotefittinginquires/uploadimagetoattachment`, "POST", formdata);

export const getunsubmittedfittingdata = (formdata) => apiCall(`${API_URL}remotefittinginquires/getunsubmittedfittingdata`, "POST", formdata);

export const getunsubmittedstudionfittingdata = (formdata) => apiCall(`${API_URL}remotefittinginquires/getunsubmittedstudionfittingdata`, "POST", formdata);

export const updatevalidatedata = (formdata) => apiCall(`${API_URL}remotefittinginquires/updatevalidatedata`, "POST", formdata);

export const updateirontestdata = (formdata) => apiCall(`${API_URL}remotefittinginquires/updateirontestdata`, "POST", formdata);

export const saveattachementdata = (formdata) => apiCall(`${API_URL}remotefittinginquires/saveattachementdata`, "POST", formdata);

export const updatelaststedata = (formdata) => apiCall(`${API_URL}remotefittinginquires/updatelaststedata`, "POST", formdata);

export const updatepassword = (formdata) => apiCall(`${API_URL}user/updatepassword`, "POST", formdata);

export const updatewhiteironimages = (formdata) => multipartApiCall(`${API_URL}remotefittinginquires/updatewhiteironimages`, "POST", formdata);
export const updateblackironimages = (formdata) => apiCall(`${API_URL}remotefittinginquires/updateblackironimages`, "POST", formdata);
export const updateblueironimages = (formdata) => apiCall(`${API_URL}remotefittinginquires/updateblueironimages`, "POST", formdata);
export const updatePinkironimages = (formdata) => apiCall(`${API_URL}remotefittinginquires/updatePinkironimages`, "POST", formdata);
export const updatePurpleironimages = (formdata) => apiCall(`${API_URL}remotefittinginquires/updatePurpleironimages`, "POST", formdata);
export const updateRedironimages = (formdata) => apiCall(`${API_URL}remotefittinginquires/updateRedironimages`, "POST", formdata);
export const updateOrangeironimages = (formdata) => apiCall(`${API_URL}remotefittinginquires/updateOrangeironimages`, "POST", formdata);
export const updateGreenironimages = (formdata) => apiCall(`${API_URL}remotefittinginquires/updateGreenironimages`, "POST", formdata);
export const updateBallData = (formdata) => multipartApiCall(`${API_URL}remotefittinginquires/updatedBallData`, "POST", formdata);


export const removecustomer = (formdata) => apiCall(`${API_URL}user/removecustomer`, "POST", formdata);
export const removefitter = (formdata) => apiCall(`${API_URL}user/removefitter`, "POST", formdata);
export const removebuilderfitter = (formdata) => apiCall(`${API_URL}staff/removefitterbuilder`, "POST", formdata);
export const updatepreferredclub = (formdata) => multipartApiCall(`${API_URL}remotefittinginquires/updatepreferredclub`, "POST", formdata);

